var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 800,
    viewBox: "0 -9 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 57,
    height: 39,
    rx: 3.5,
    fill: "#fff",
    stroke: "#F3F3F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.752 27.433H21.89l2.415-14h3.862l-2.415 14zM39.75 13.775a10.074 10.074 0 00-3.464-.596c-3.813 0-6.498 1.906-6.515 4.632-.031 2.01 1.923 3.127 3.385 3.798 1.494.685 2.001 1.132 2.001 1.743-.015.938-1.207 1.37-2.319 1.37-1.541 0-2.367-.223-3.623-.744l-.508-.224-.54 3.143c.905.387 2.574.73 4.306.745 4.052 0 6.69-1.877 6.72-4.782.016-1.593-1.016-2.815-3.24-3.813-1.351-.64-2.178-1.072-2.178-1.727.016-.596.7-1.207 2.224-1.207a6.935 6.935 0 012.877.536l.349.15.525-3.024z",
    fill: "#15195A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.662 13.432h2.987l3.115 14.001h-3.576s-.35-1.609-.46-2.1H43.77l-.81 2.1h-4.052l5.736-12.839c.397-.909 1.097-1.162 2.018-1.162zm-.238 5.124s-1.224 3.113-1.542 3.917h3.21c-.159-.7-.89-4.051-.89-4.051l-.27-1.206c-.114.31-.278.737-.389 1.025-.075.196-.126.327-.12.315zM5.159 13.432h6.213c.842.03 1.525.283 1.747 1.177l1.35 6.433.001.001.413 1.937 3.782-9.548h4.083l-6.07 13.986h-4.083L9.153 15.253c-1.187-.65-2.542-1.174-4.058-1.538l.064-.283z",
    fill: "#15195A"
  })));
}
export default SvgVisa;